import React, { useState } from "react"
import { Edit, useRecordContext, useTranslate } from "react-admin"
import { useNavigate } from "react-router-dom"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import DashboardViewer from './viewer'
import DashboardCreationWizardMUI from './create.wizard'
import WidgetCreationWizard from './widget.creation'
import { DashboardWidget } from 'types/dashboard.ui'

function DashboardEditForm(): JSX.Element {
    const translate = useTranslate()
    const record = useRecordContext()
    const [editingWidget, setEditingWidget] = useState<DashboardWidget | null>(null)
    const [widgetDialogOpen, setWidgetDialogOpen] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)
    
    if (!record || !record.id) {
        return <div>{translate('resources.dashboards.messages.loading')}</div>
    }

    const handleEditWidget = (widget: DashboardWidget) => {
        setEditingWidget(widget)
        setWidgetDialogOpen(true)
    }

    const handleWidgetDialogClose = () => {
        setWidgetDialogOpen(false)
        setEditingWidget(null)
    }

    const handleWidgetSuccess = () => {
        setWidgetDialogOpen(false)
        setEditingWidget(null)
        // Обновляем дашборд, чтобы показать изменения
        setRefreshKey(prev => {
            const newKey = prev + 1;
            return newKey;
        })
    }

    return (
        <>
            <DashboardViewer
                key={refreshKey}
                dashboardId={String(record.id)}
                editMode={true}
                onEditModeChange={(editMode) => {
                }}
                onEditWidget={handleEditWidget}
            />
            
            <WidgetCreationWizard
                open={widgetDialogOpen}
                onClose={handleWidgetDialogClose}
                onSuccess={handleWidgetSuccess}
                dashboardId={String(record.id)}
                widget={editingWidget || undefined}
            />
        </>
    )
}

function DashboardEdit(): JSX.Element {
    const [showCreateWizard, setShowCreateWizard] = useState(false)
    const navigate = useNavigate()

    const handleWizardClose = () => {
        setShowCreateWizard(false)
    }

    const handleWizardSuccess = (dashboardId: string) => {
        setShowCreateWizard(false)
        navigate(`/dashboards/management/${dashboardId}`)
    }

    const handleCreateClick = () => {
        setShowCreateWizard(true)
    }

    const subTabs: SubTabProps[] = [
        // Здесь можно добавить дополнительные табы, например:
        // { label: translate("resources.schedules.name"), name: "schedules", resource: "dashboards/management", icon: <ScheduleIcon/> },
    ]

    return (
        <>
        <Edit 
            redirect="show" 
            mutationMode="pessimistic" 
            actions={<RecordActionsTabs subTabs={subTabs} resourceParent="dashboards/management" onCreateClick={handleCreateClick}/>}
            sx={{ 
                width: '100%',
                '& .RaEdit-main': { 
                    height: 'calc(100vh - 64px)',
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '100% !important',
                    width: '100%'
                },
                '& .RaEdit-card': {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    maxWidth: '100% !important',
                    width: '100%',
                    margin: '0 !important',
                    boxShadow: 'none',
                    padding: '0 !important'
                }
            }}
        >
            <DashboardEditForm />
        </Edit>
        
        <DashboardCreationWizardMUI
            open={showCreateWizard}
            onClose={handleWizardClose}
            onSuccess={handleWizardSuccess}
        />
        </>
    )
}

export default DashboardEdit
